import { listPartners } from '@app/enums/shop';
import { Htag, TagTape } from '@app/shared';

interface TitlePageProps {
  className?: string;
  title: string;
  partners: NonNullable<number>;
}

// Нет партнера - Колесо.ру
// 5 Колесо - «5 Колесо»
// Мой автомобиль - «Мой автомобиль»
// Магазин партнер - Партнерский центр

export const TitlePage = ({ className, title, partners }: TitlePageProps) => {
  return (
    <Htag tag={TagTape.H1} className={className} itemProp="name">
      {partners ? listPartners[partners - 1] : 'Колесо.ру'} {title}
    </Htag>
  );
};
